import { render, staticRenderFns } from "./secureChat.vue?vue&type=template&id=26236f05&scoped=true&"
import script from "./secureChat.vue?vue&type=script&lang=js&"
export * from "./secureChat.vue?vue&type=script&lang=js&"
import style0 from "./secureChat.vue?vue&type=style&index=0&id=26236f05&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26236f05",
  null
  
)

export default component.exports